export default __webpack_public_path__ + "static/media/060_corner2.first.9cc7ec34.webp";